import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { LogOut, User as UserIcon, Film } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";

export const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <nav
      data-testid="main-navbar"
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-black/60 border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12 h-16 flex items-center justify-between">
        <Link to={user ? "/dashboard" : "/"} data-testid="nav-logo" className="flex items-center gap-2 group">
          <Film className="w-5 h-5 text-[#FF2A2A] group-hover:rotate-12 transition-transform" />
          <span className="font-display font-black tracking-tighter text-xl">
            LIFE<span className="text-[#FF2A2A]">REPLAY</span>
          </span>
        </Link>

        {user ? (
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <button
                data-testid="user-menu-trigger"
                className="flex items-center gap-3 px-3 py-2 hover:bg-white/5 transition-colors rounded-sm"
              >
                {user.picture ? (
                  <img src={user.picture} alt={user.name} className="w-8 h-8 rounded-full ring-1 ring-white/20" />
                ) : (
                  <div className="w-8 h-8 rounded-full bg-[#FF2A2A] flex items-center justify-center font-bold text-sm">
                    {user.name?.charAt(0) || "U"}
                  </div>
                )}
                <span className="hidden sm:inline font-mono text-xs uppercase tracking-widest text-white/70">
                  {user.name}
                </span>
              </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="bg-[#121212] border border-white/10 text-white font-mono">
              <DropdownMenuLabel className="font-mono text-xs uppercase tracking-widest text-white/50">
                {user.email}
              </DropdownMenuLabel>
              <DropdownMenuSeparator className="bg-white/10" />
              <DropdownMenuItem
                data-testid="nav-dashboard"
                onClick={() => navigate("/dashboard")}
                className="cursor-pointer focus:bg-white/10 focus:text-white"
              >
                <UserIcon className="w-4 h-4 mr-2" /> My Episodes
              </DropdownMenuItem>
              <DropdownMenuItem
                data-testid="nav-logout"
                onClick={logout}
                className="cursor-pointer focus:bg-white/10 focus:text-white text-[#FF2A2A]"
              >
                <LogOut className="w-4 h-4 mr-2" /> Sign out
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        ) : (
          <Link
            to="/login"
            data-testid="nav-signin"
            className="font-mono text-xs uppercase tracking-widest px-5 py-2.5 bg-[#FF2A2A] hover:bg-[#FF5555] text-white transition-colors"
          >
            Sign in
          </Link>
        )}
      </div>
    </nav>
  );
};
